<template>
  <div class="flex flex-col gap-y-[24px]">

    <div class="bg-surface-primary p-[16px] rounded-[8px]">
      <DynamicAlghoritmForm
        :formConfig="algorithmData?.formConfig"
        :fullKzsFormData="fullKzsFormData"
        @on-update-step-result="handleStepResultUpdate"
      />
    </div>

     <div class="flex gap-x-[8px]">
       <VButton type="light" label="Назад" @click="prevStepHandler" size="m" />
       <VButton type="primary" label="Далее" @click="nextStepHandler" size="m" :disabled="!isAllFieldsFilled" />
     </div>
 </div>
</template>

<script>
import { VButton } from '@gostelemed.front/rt-doctis.designsystem';
import DynamicAlghoritmForm from './FormParts/DynamicAlghoritmForm.vue';
export default {
  name: 'CreateKzsFormStep3',
  components: {
    VButton,
    DynamicAlghoritmForm,
  },
  props: {
    fullKzsFormData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    algorithmData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  data() {
    return {
      isAllFieldsFilled: false,
    }
  },
  methods: {

    prevStepHandler() {
      this.$emit('on-prev-step');
    },
    nextStepHandler() {
      this.$emit('on-next-step');
    },
    handleStepResultUpdate(result) {
      const data = {
        params: result
      }
      this.isAllFieldsFilled = this.isFilledDeep(result);
      this.$emit('on-update-alghoritm-params', data);
    },
    // Проверка на заполненность всех полей вложенного объекта
    isFilledDeep(value) {
      if (value === null || typeof value === 'undefined') return false;

      if (typeof value === 'string') return value.trim().length > 0;

      if (Array.isArray(value)) {
        if (!value.length) return false;
        return value.every((item) => this.isFilledDeep(item));
      }

      if (typeof value === 'object') {
        const objectValues = Object.values(value);
        if (!objectValues.length) return false;
        return objectValues.every((item) => this.isFilledDeep(item));
      }

      // number/boolean считаем валидными (в т.ч. 0 и false)
      return true;
    },
  },
}
</script>
